/* Maison Atlas : comportements partages des sections ma- (videos, tuiles interactives, double photo, carrousel, barre d'achat). */
(() => {
  if (window.maSectionsReady) return;
  window.maSectionsReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const touchOnly = window.matchMedia('(hover: none)').matches;
  const canAutoplay = !reduceMotion && !saveData && 'IntersectionObserver' in window;

  const videoObserver = canAutoplay
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.preload = 'auto';
              const playing = video.play();
              if (playing && playing.catch) playing.catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.55 }
      )
    : null;

  function initVideos(scope) {
    scope.querySelectorAll('.ma-reel__media video').forEach((video) => {
      if (video.dataset.maBound) return;
      video.dataset.maBound = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('tabindex', '-1');
      video.setAttribute('aria-hidden', 'true');
      if (videoObserver) videoObserver.observe(video);
    });
  }

  function initTiles(scope) {
    if (!touchOnly) return;
    scope.querySelectorAll('[data-ma-tile-link]').forEach((link) => {
      if (link.dataset.maBound) return;
      link.dataset.maBound = 'true';
      link.addEventListener('click', (event) => {
        const tile = link.closest('[data-ma-tile]');
        if (!tile || tile.dataset.hasAlt !== 'true' || tile.classList.contains('is-revealed')) return;
        event.preventDefault();
        document.querySelectorAll('[data-ma-tile].is-revealed').forEach((other) => other.classList.remove('is-revealed'));
        tile.classList.add('is-revealed');
      });
    });
  }

  function initDoublePhotos(scope) {
    scope.querySelectorAll('[data-ma-sens-media]').forEach((media) => {
      if (media.dataset.maBound) return;
      media.dataset.maBound = 'true';
      const dots = Array.from(media.querySelectorAll('[data-ma-dot]'));
      const show = (index) => {
        media.classList.toggle('is-alt', index === 1);
        dots.forEach((dot) => dot.setAttribute('aria-pressed', Number(dot.dataset.maDot) === index ? 'true' : 'false'));
      };
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.maDot))));
      if (!touchOnly && dots.length > 1) {
        media.addEventListener('mouseenter', () => show(1));
        media.addEventListener('mouseleave', () => show(0));
      }
    });
  }

  function initCarousels(scope) {
    scope.querySelectorAll('[data-ma-carousel]').forEach((carousel) => {
      if (carousel.dataset.maBound) return;
      carousel.dataset.maBound = 'true';
      const track = carousel.querySelector('[data-ma-track]');
      if (!track) return;
      carousel.querySelectorAll('[data-ma-dir]').forEach((button) => {
        button.addEventListener('click', () => {
          const first = track.firstElementChild;
          const step = first ? first.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
          track.scrollBy({ left: Number(button.dataset.maDir) * step, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function initStickyBars(scope) {
    scope.querySelectorAll('[data-ma-sticky]').forEach((bar) => {
      if (bar.dataset.maBound) return;
      bar.dataset.maBound = 'true';
      let closed = false;
      try {
        closed = window.sessionStorage.getItem('ma-sticky-closed') === '1';
      } catch (error) {
        closed = false;
      }
      if (closed) {
        bar.remove();
        return;
      }
      /* Hors de l'editeur, la barre est rattachee au body : les animations d'entree des sections creent un conteneur qui casserait position: fixed. */
      if (!document.documentElement.classList.contains('theme-editor')) {
        document.querySelectorAll('body > [data-ma-sticky]').forEach((old) => {
          if (old !== bar) old.remove();
        });
        document.body.appendChild(bar);
      }
      const hero = document.querySelector('[data-ma-hero]') || document.querySelector('main .shopify-section');
      const footer = document.querySelector('footer.footer');
      let pastHero = false;
      let nearFooter = false;
      const update = () => {
        const visible = pastHero && !nearFooter;
        bar.classList.toggle('is-visible', visible);
        bar.toggleAttribute('inert', !visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      if ('IntersectionObserver' in window) {
        if (hero) {
          new IntersectionObserver(([entry]) => {
            pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            update();
          }).observe(hero);
        }
        if (footer) {
          new IntersectionObserver(([entry]) => {
            nearFooter = entry.isIntersecting;
            update();
          }).observe(footer);
        }
      }
      const close = bar.querySelector('[data-ma-sticky-close]');
      if (close) {
        close.addEventListener('click', () => {
          try {
            window.sessionStorage.setItem('ma-sticky-closed', '1');
          } catch (error) {
            /* stockage indisponible : la barre se ferme pour cette page seulement */
          }
          bar.remove();
        });
      }
      update();
    });
  }

  const init = (scope) => {
    initVideos(scope);
    initTiles(scope);
    initDoublePhotos(scope);
    initCarousels(scope);
    initStickyBars(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
